import React from "react";
import styled from "styled-components";
import BaseSection from "../BaseSection";

function Footer(props) {
  return (
    <Wrapper>
      <div className="content">
        

        <div style={{ flex: "0 0 10px" }} />

        <div className="copyright">COPYRIGHT ©RevtelTech ALL RIGHT RESERVED</div>

        
        <div style={{ flex: "0 0 10px" }} />

      </div>
    </Wrapper>
  );
}

const Wrapper = styled(BaseSection)`
  background-color: transparent;

  & > .content {
    border-top: 1px solid yellow;
    padding-bottom: 80px;

    & > * {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }

    & > div:first-child {
      & img.item {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: contain;
        background-color: #ccc;
        margin: 3px;
      }
    }

    & > .copyright {
      flex: 1;
      text-align: center;
      margin: 0;
      color: white;
    }

    & > div:last-child {
      & .item {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: contain;
        background-color: #ccc;
        margin: 3px;
      }
    }
  }
`;

export default Footer;
